import { View, Image, Text, Button, Actionable } from "reshaped";
import { WorkItemProps } from "./WorkItem.types";

export const WorkItem = (props: WorkItemProps) => {
  const { list } = props;

  return (
    <View
      direction="column"
      padding={6}
      borderColor="neutral"
      borderRadius="medium"
    >
      <Image displayMode="contain" src={list.img} height={70} width="100%" />
      <View paddingTop={6} paddingBottom={1} height={20}>
        <Text variant="body-2" weight="bold" maxLines={2}>
          {list.title}
        </Text>
      </View>

      <Text variant="body-3">{list.description}</Text>
      <Text variant="body-3">{list.position}</Text>

      <View paddingBlock={6} paddingInline={0}>
        <Actionable href={list.url} attributes={{ target: "_blank" }}>
          <Button color="primary">
            <Text variant="body-3">Ir a {list.title}</Text>
          </Button>
        </Actionable>
      </View>
    </View>
  );
};
